import { mediaItems } from '@/mocks/home-data';

export default function MediaSection() {
  return (
    <section id="media" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-8">
          漫剪精选
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-[10px] font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-bold text-foreground-950 mb-1.5 line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>
                    <i className="ri-eye-line mr-0.5"></i>
                    {item.views}
                  </span>
                  <span>{item.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}